import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { Campaign, DefaultHomepage, GetCampaignByIdNoTagsGQL } from 'generated/graphql';
import { isNilOrEmpty } from 'helpers';
import { AppPersistantStateService, StoreNames } from '../state/app-state.service';

/**
 * Used on the 'root' component. Checks if a user was in another campaign
 * in their last session and redirects them to the appropriate default page
 * based on the campaign's defaultHomepage setting.
 */
export const restoreCampaignGuard = (_route, state) => {
  const router = inject(Router);
  const appPersistantStateService = inject(AppPersistantStateService);
  const getCampaignGQL = inject(GetCampaignByIdNoTagsGQL);

  if (state.url !== '/') {
    return true;
  }

  // Check persistent local storage to restore the campaign
  const currentCampaignInState = appPersistantStateService.getValue<Partial<Campaign>>(StoreNames.CurrentCampaign);

  if (isNilOrEmpty(currentCampaignInState)) {
    return router.parseUrl(`/select-campaign`);
  }

  const campaignId = currentCampaignInState.id;

  // Fetch campaign to check defaultHomepage setting
  return getCampaignGQL.fetch({ campaignId }).pipe(
    map(({ data }) => data.getCampaign),
    map((campaign) => {
      if (campaign.defaultHomepage === DefaultHomepage.Overview) {
        return router.parseUrl(`/dashboard?campaignId=${campaignId}`);
      }

      return router.parseUrl(`/entity/list?campaignId=${campaignId}`);
    })
  );
};
